import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=1c03fb5a&scoped=true&"
import script from "./modal.ts?vue&type=script&lang=ts&"
export * from "./modal.ts?vue&type=script&lang=ts&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=1c03fb5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c03fb5a",
  null
  
)

export default component.exports